import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {IonRow, ModalController} from '@ionic/angular';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';
import {CustomerResourceService} from '../../../services/database/resource/customer-resource.service';
import {GeneralService} from '../../../services/general.service';

@Component({
    selector: 'app-equip-list-return-scaffolding',
    templateUrl: './equip-list-return-scaffolding.page.html',
    styleUrls: ['./equip-list-return-scaffolding.page.scss'],
})
export class EquipListReturnScaffoldingPage implements OnInit {

    @Input() document: DocumentModel;
    @Input() groupedDetailLines = [];
    @ViewChild('row') row: IonRow;
    @Input() currentGroupedItems: any;
    detailLinesDTO: DetaillineDTOModel[];
    queryText = '';
    lightColor = 'white';
    darkColor = '#EDEDED';

    constructor(private customerRes: CustomerResourceService,
                private modalController: ModalController,
                private generalService: GeneralService) {
    }

    async ngOnInit() {
    }

    async ionViewWillEnter() {
        for (const line of this.groupedDetailLines) {
            line.isChecked = false;
        }
        await this.checkLinePresent();
    }

    checkQty(event, dtLine: any) {
        // dtLine.isChecked = true;
        if (event.detail.value > dtLine.line.maxReturnQty) {
            this.generalService.createToast('Quantity invalid! Max Qty: ' + dtLine.line.maxReturnQty);
            dtLine.line.qty = dtLine.line.maxReturnQty;
        }
    }

    cancel() {
        this.modalController.dismiss();
    }

    checkLinePresent() {
        console.log(this.currentGroupedItems);
        if (this.currentGroupedItems.length > 0) {
            for (const line of this.groupedDetailLines) {
                for (const docLine of this.currentGroupedItems) {
                    if (line.line.pdesc === docLine.pdesc) {
                        line.isChecked = true;
                        line.line.qty = docLine.qty;
                        break;
                    }
                }
            }
        }
    }

    addDetailLines() {
        this.detailLinesDTO = [] as DetaillineDTOModel[];
        this.currentGroupedItems = [];
        for (const line of this.groupedDetailLines) {
            if (line.isChecked) {
                this.currentGroupedItems.push(line.line);
            }
        }
        console.log(this.detailLinesDTO);
        this.modalController.dismiss(this.currentGroupedItems);
    }
}

